import React, { ReactNode, ReactNodeArray } from 'react';
import { useAuth } from './AuthContext';
import { IUser } from '../Data/Users';

const UserContext = React.createContext<IUser|null>(null);

interface IUserProviderProps {
    children: ReactNode|ReactNodeArray
}

function UserProvider(props: IUserProviderProps) {
  const user = useAuth();
  return <UserContext.Provider value={user.user} {...props} />;
}

function useUser() {
  const context = React.useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}

export { UserProvider, useUser };
